import React, { FC, useMemo } from 'react';
import { WppTypography } from '@wppopen/components-library-react';
import { INotificationSections, TestIds } from 'utils';
import styles from './NotificationsSection.module.scss';

const { Main } = styles;

export const NotificationsSection: FC<INotificationSections> = ({
    sex,
    age_group,
    heritage,
    category,
    demographic,
    regeneratedData,
    geoMapState,
}) => {
    const geoMapData =
        typeof geoMapState[geoMapState.Segment] === 'string'
            ? [geoMapState[geoMapState.Segment]]
            : [...geoMapState[geoMapState.Segment]];
    const textGenerator = (data: any, divider: string, casesLength: number, allText: string) => {
        let result = '';

        if (data.length === 1) {
            result += data[0];
        }
        if (data.length > 1 && data.length !== casesLength) {
            data?.map((el: any, index: number) => {
                result += `${el} ${index < data.length - 1 ? divider : ''} `;
            });
        }
        if (data.length === casesLength) {
            result = allText;
        }
        return result.toLowerCase();
    };

    const ReadyComponent = useMemo(() => {
        return (
            <div data-testid={TestIds.scenario.generatedText}>
                <WppTypography type="s-body">For</WppTypography>{' '}
                <WppTypography type="m-strong">
                    {textGenerator(sex.split(','), 'or', 2, 'all sexes')}
                </WppTypography>{' '}
                <WppTypography type="s-body">in</WppTypography>{' '}
                <WppTypography type="m-strong">
                    {textGenerator(age_group, 'or', 5, 'all')}
                </WppTypography>{' '}
                <WppTypography type="s-body"> age group(s) across</WppTypography>{' '}
                <WppTypography type="m-strong" style={{ display: 'inline' }}>
                    {textGenerator(heritage, 'or', 5, 'all')}
                </WppTypography>{' '}
                <WppTypography type="s-body">ethnic group(s) in the</WppTypography>{' '}
                <WppTypography type="m-strong" style={{ display: 'inline' }}>
                    {textGenerator(geoMapData, 'or', 4, 'all')}
                </WppTypography>{' '}
                <WppTypography type="s-body">{`${geoMapState.Segment.toLowerCase()}(s)`}</WppTypography>{' '}
                <WppTypography type="s-body">we are increasing the engagement in the</WppTypography>{' '}
                <WppTypography type="m-strong" style={{ display: 'inline' }}>
                    {textGenerator(category, 'and', 5, 'all')}
                </WppTypography>{' '}
                <WppTypography type="s-body">category by</WppTypography>{' '}
                <WppTypography type="m-strong">{demographic}%</WppTypography>{' '}
            </div>
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [regeneratedData]);

    return <div className={Main}>{ReadyComponent}</div>;
};
